// extracted by mini-css-extract-plugin
export var wordContainer = "_rh-0";